<template lang="pug">
.document-asset-list
	.no-content( v-if='driveLinkState != "valid"' )
		p.spacey {{  noContentMessage  }}
	.content( v-else )
		.no-directories( v-if='!directories || !directories.length' )
			p.spacey No Files Saved to this entity.
		.directories( v-else )
			.directory( v-for="( directory, index ) in directories" :key="index" )
				.no-documents( v-if="!files[directory.folderUri] || !files[directory.folderUri].length" )
					p {{ directory.folderUri }}
				.documents( v-else )
					.document( v-for="( file, index ) in files[directory.folderUri]" :key='index' @click='openDocument( file.name, directory.folderUri )' )
						p {{  directory.folderUri  }}\{{  file.name  }}
</template>

<script>
import Vue from 'vue';
import fs from 'fs';

export default {
	name : 'document-asset-list',

	props : {
		documents : {
			type : Array
		},
		emptyMessage : {
			type : String
		},
		activeFiles : {
			type : Array
		}
	},

	data : () => ( {
		files   : {},
		confirm : false,
	} ),

	computed : {
		driveLink() {
			return this.$store.getters.postgresUser.driveLink;
		},

		directories() {
			return this.documents.filter( a => a.folderUri || a.folderUri.trim() !== '' );
		},

		isElectron() {
			return this.$store.state.isElectron;
		},

		driveLinkState() {
			return this.$store.state.driveLinkState;
		},

		noContentMessage() {
			const { driveLinkState } = this;

			const messages = {
				'not-electron' : 'Switch to the Desktop app to view documents',
				'invalid'      : 'G Drive file path is invalid. Click settings in the side bar to change it.',
				'valid'        : ''
			};

			return messages[driveLinkState];
		}
	},

	watch : {
		directories : {
			immediate : true,
			handler( directories ) {
				if ( !directories ) return;
				if ( !directories.length ) return;
				if ( !this.isElectron ) return;
				this.readDirectories( directories );
			}
		}
	},

	methods : {
		readDirectories( directories ) {
			const { driveLink } = this;

			directories.forEach( ( directory ) => {
				const { folderUri } = directory;

				this.folderUri = folderUri;

				if ( !this.activeFiles[0] ) return;

				/**
				 * @param { string } string - the string that we'll use to see if there is
				 * a slash at the beginning of or not. If so, we will remove the slash, if
				 * not, we will keep the string as is.
				 */
				const removeSurroundingSlashes = ( string ) => {
					let localString = string;

					// check the first character for a slash, if so, remove it so that we can
					// combine the driveLink and the folderUri to make "filePath"
					if ( localString.charAt( 0 ) === '/' || localString.charAt( 0 ) === '\\' ) {
						localString = localString.substring( 1 );
					}

					const lastCharacterIndex = localString.length - 1;
					const lastCharacter = localString.charAt( lastCharacterIndex );

					// check the last character in directory path for slash, if true, remove it.
					if ( lastCharacter === '/' || lastCharacter === '\\' ) {
						localString = localString.slice( 0, lastCharacterIndex );
					}

					return localString;
				};

				let filePath = `${driveLink}/${folderUri}`;

				// if this is a mac machine, we need to replace all \ with /.

				if ( process.platform === 'darwin' ) {
					const splitPath = filePath.split( '\\' );

					filePath = splitPath.reduce( ( formattedString, partOfString ) => {
						let localString = formattedString;

						localString += `/${removeSurroundingSlashes( partOfString )}`;

						return localString;
					}, '' );
				}

				// if a windows machiene, we need to replcae all / with \.
				if ( process.platform === 'win32' ) {
					const splitPath = filePath.split( '/' );

					filePath = splitPath.reduce( ( formattedString, partOfString ) => {
						let localString = formattedString;

						if ( partOfString.charAt( partOfString.length - 1 ) === ':' ) return `${partOfString}`;
						if ( !localString ) return partOfString;
						if ( !partOfString || partOfString === '' ) return localString;

						localString += `${removeSurroundingSlashes( partOfString )}\\`;

						return localString;
					}, '' );
				}

				if ( !fs.existsSync( filePath ) ) return;

				const files = fs.readdirSync( filePath );

				const savedFiles = this.activeFiles.filter( ( f ) => {
					const exp = files.filter( file => file === f.name );

					if ( exp[0] ) return exp[0] === f.name;
					return exp === f.name;
				} );

				Vue.set( this.files, folderUri, savedFiles );
			} );
		},

		openDocument( document, directory ) {
			const filePath = `${directory}/${document}`;

			this.$store.dispatch( 'openDocument', filePath );
		},
	}
};
</script>

<style lang="scss">
.document-asset-list {
	position: relative;
	display: flex;
	flex-flow: column;
	align-items: center;

	.no-content {
		width: 100%;

		p {
			text-align: center;
			font-size: 16px;
		}
	}

	.content {
		width: 100%;

		.no-directories {
			p {
				text-align: center;
			}
		}

		.directories {
			width: 100%;

			.directory {
				margin-bottom: 20px;

				.directory-name {
					margin-bottom: 10px;
					margin-left: 10px;

					p {
						color: $color-primary;
						letter-spacing: 2px;
					}
				}
			}
		}

		.no-documents {
			margin-left: 10px;
		}

		.document {
			display: flex;
			align-items: center;
			background: white;
			margin-bottom: 15px;
			border-radius: 10px;
			box-shadow: $secondaryBoxShadow;
			width: 100%;
			transition: all 0.2s ease-in-out;

			p {
				flex: 1 1 0;
			}

			> p,
			.download-button,
			.delete-button {
				padding: 10px;
			}

			&:hover {
				cursor: pointer;
				transform: scale( 1.05 );
				box-shadow: $hoverBoxShadow;
			}

			&:active {
				transform: scale( 1 );
				box-shadow: $secondaryBoxShadow;
			}
		}
	}
}
</style>
